
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sparepart/[...url]",
      function () {
        return require("private-next-pages/sparepart/[...url].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sparepart/[...url]"])
      });
    }
  